import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { Text, FontWeight } from '../Text';

const Container = styled.div`
  position: relative;
  padding: 2rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  padding-bottom: 0px;

  @media screen and (max-width: 768px) {
    padding: 1.5rem 0;
    align-items: flex-start;
  }

  .profile-open{
    right: 0px;
  }

`;

const Column = styled.div`
  @media screen and (max-width: 768px) {
    min-width: 93px;
  }
`;

const Title = styled(Text)`
  display: block;
  margin-bottom: .25rem;
  line-height: 1.4;
  font-size: 32px;
  font-weight: ${FontWeight.Bold};
  color1: ${Colors.WHITE};
  color: ${Colors.GRAY[6]};

  @media screen and (max-width: 768px) {
    line-height: 1;
  }
`;

const Subtitle = styled(Text)`
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  color1: ${Colors.WHITE};
  color: ${Colors.GRAY[6]};

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 120px;
  margin: 2rem 4px;
  max-inline-size: min-content;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    max-height: 75px;
    margin-top: 50px;
  }
`;

const ContentProfile = styled.div`
  right: -340px;
  width: 340px;
  height: 100vh;
  position: fixed;
  background: ${Colors.WHITE};
  box-shadow: -5px 0px 6px 1px rgba(179,174,174,0.17);
  z-index: 10;
  top: 0px;
  transition: all 0.5s ease;
  overflow-y: auto;
  overflow-x: hidden;

  .icon-close{
    z-index: 100;
    position: relative;
    margin: 10px 15px;
    font-size: 30px;
    cursor: pointer;
    float: left;
  }
`;

const User = styled.div`
  width: 250px;
  float: right;

  @media (max-width: 1098px) {
    width: 70px;
  }

  @media (max-width: 499px) {
    width: 50px;
  }
`;

const Photo = styled.div`
  width: 60px;
  height: 60px;
  background: #fff;
  box-shadow: 0px 8px 20px 3px rgba(171, 171, 171, 0.22);
  border-radius: 50px;
  margin-top: -10px;
  padding-top: 10px;
  margin-right: 20px;
  float: left;

  .icon-user:before{
    background-size: contain;
    width: 38px;
    height: 32px;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 2px;
  }

  .icon-check-ok{
    margin-left: 40px;
    margin-top: -5px;
    float: right;
  }

  .icon-check-ok:before {
    background-size: contain;
    display: inline-block;
    width: 24px;
    height: 24px;
    content: "";
    border-radius: 20px;
  }

  @media (max-width: 499px) {
    width: 50px;
    height: 50px;

    .icon-user:before{
      width: 32px;
      height: 27px;
    }

    .icon-check-ok:before {
      width: 20px;
      height: 20px;
    }
  }
`;

const Name = styled(Text)`
  font-size: 16px;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};
  @media (max-width: 1098px) {
    display: none;
  }
`;

const Country = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};

  @media (max-width: 1098px) {
    display: none;
  }
`;

export { Container, Column, Title, Subtitle, Logo, ContentProfile, Country,Name, Photo, User};
